import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";
import Loading from '../../core/common/loader/index';
import { apibaseurl } from "../../environment";

const Assessment: React.FC = () => {
  const [employee, setEmployee] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState<any>(false);
  const [selectedTrainer, setSelectedTrainer] = useState<any>([]);



  const {
    data: employeeData,
    error,
    callApi: fetchEmployees
  } = useApi("/api/get-assessment-employee", {
    method: "GET",
    autoCall: false,
  });



  useEffect(() => {
    if (employeeData?.data) {
      setEmployee(employeeData.data);
    }
    if (error) {
      Swal.fire("Error", "Failed to fetch data", "error");
    }
  }, [employeeData, error]);


  const { data: deleteItem, callApi: handleDeleteItem } = useApi("/api/delete-nomination", {
    method: "DELETE",
    autoCall: false,
  });

  const handleDelete = async (id: any) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const response = await handleDeleteItem(undefined, "/api/delete-nomination/" + id);

        if (response.success) {
          await Swal.fire("Deleted!", response?.message || "Your item has been deleted.", "success");

          setRefreshTrigger((prev: boolean) => !prev);
        } else {
          console.log("1")
          await Swal.fire("Failed!", response?.message || "Failed to delete the item.", "error");
        }
      }
    } catch (error: any) {
      console.log("2")
      await Swal.fire("Error!", error?.response?.data?.message || "Error while deleting item", "error");
    }
  };


  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await fetchEmployees();
      setLoading(false);
    };
    loadData();
  }, [refreshTrigger]);


  useEffect(() => {
    if (deleteItem?.success) {
      console.log("Item deleted successfully. Refresh your list.");
      setRefreshTrigger(true);
    }
  }, [deleteItem, employee]);

  const columns2 = [
    {
      title: "Training Title",
      dataIndex: "training_title",
      key: "training_title",
      sorter: (a: any, b: any) => a.training_title.localeCompare(b.training_title),
    },
    {
      title: "Venue",
      dataIndex: "venue",
      key: "venue",
      sorter: (a: any, b: any) => a.venue.localeCompare(b.venue),
    },
    {
      title: "Delivery Mode",
      dataIndex: "delivery_plan",
      key: "delivery_plan",
      sorter: (a: any, b: any) => a.delivery_plan.localeCompare(b.delivery_plan),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: (a: any, b: any) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: (a: any, b: any) =>
        new Date(a.end_date).getTime() - new Date(b.end_date).getTime(),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text: string) => {
        const preview = text.length > 80 ? `${text.slice(0, 80)}...` : text;
        return (
          <span title={text} style={{ cursor: "help" }}>
            {preview}
          </span>
        );
      },
    },
    {
      title: "Attachment",
      dataIndex: "file",
      key: "file",
      render: (file: string) => {
        if (!file) return <span className="text-muted">No File</span>;
        return (
          <a
            href={`${apibaseurl}/${file}`}
            target="_blank"
            rel="noopener noreferrer"
            title="View File"
            className="text-primary"
          >
            View
          </a>
        );
      },
    },
  ];


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Heading and Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Assessment</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Training Management</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Assessment
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Card Container */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
              <h5 className="mb-0">Assessment List</h5>
            </div>
            <div className="card-body">
              <div className="card table-responsive">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "300px" }}
                  >
                    <Loading />
                  </div>
                ) : (
                  <Table dataSource={employee} columns={columns2} Selection={false}  showSearchInput={true}/>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* view modal  */}

        {selectedRecord && (
          <div
            className={`modal fade ${showRejectionModal ? "show d-block" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }} // overlay
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-danger">Rejection Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowRejectionModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p><strong>Training Title:</strong> {selectedRecord.training_title}</p>
                  <p><strong>Rejected By:</strong> {selectedRecord.rejected_by || "N/A"}</p>
                  <p><strong>Rejection Reason:</strong> {selectedRecord.rejection_reason || "Not provided"}</p>
                  <p>
                    <strong>Rejected On:</strong>{" "}
                    {selectedRecord.rejected_on
                      ? new Date(selectedRecord.rejected_on).toLocaleString()
                      : "N/A"}
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowRejectionModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      <div className="modal fade" id="trainer_information">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Trainer Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-bordered table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Trainer Name</th>
                      <th>Gender</th>
                      <th>Expertise Area</th>
                      <th>Experience</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedTrainer?.length > 0 ? (
                      selectedTrainer.map((record: any, index: any) => (
                        <tr key={index}>
                          <td>
                            <div
                              className="d-flex align-items-center"
                              style={{ minWidth: "180px" }}
                            >
                              <img
                                src={
                                  record.profile_picture
                                    ? `${apibaseurl}/${record.profile_picture}`
                                    : "./assets/img/logo/profilepic.jpg"
                                }
                                alt={record.full_name}
                                className="rounded-circle me-2"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                              <span className="fs-14 fw-medium">
                                {record.full_name}
                              </span>
                            </div>
                          </td>
                          <td style={{ minWidth: "140px" }}>
                            {record.gender}
                          </td>
                          <td style={{ minWidth: "140px" }}>
                            {record.expertise_area}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {record.experience} years
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center text-muted py-3">
                          No trainer data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Assessment;
